import CheckboxGroup from "../../applicationUi/components/intake/CheckboxGroup";
import RadioGroup from "../../applicationUi/components/intake/RadioGroup";
import TextAreaField from "../../applicationUi/components/intake/TextAreaField"; // Assuming you have this for other input fields

const VoiceConcernsSection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-8">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">D - Voice Concerns</h2>
      <p className="text-sm text-muted-foreground">
        Information about voice quality and characteristics.
      </p>
    </div>

    {/* Does your child have voice problems? */}
    <RadioGroup
      label="Does your child have voice problems?"
      name="voiceConcerns.hasVoiceProblems"
      options={[
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ]}
      selectedValue={formData.voiceConcerns.hasVoiceProblems}
      onChange={handleChange}
      readOnly={isReadOnly}
    />

    {/* If No, prompt to move to the next section */}
    {formData.voiceConcerns.hasVoiceProblems === "no" && (
      <p className="text-sm text-gray-500">Please proceed to Section E.</p>
    )}

    {/* Conditional Rendering: Show only if 'yes' is selected */}
    {formData.voiceConcerns.hasVoiceProblems === "yes" && (
      <>
        {/* Voice Characteristics */}
        <h3 className="font-semibold mb-2">
          Which of the following are characteristics of your child's voice?
        </h3>

        <div className="space-y-4">
          <label className="text-sm font-medium text-foreground block">Voice Characteristics</label>
          <div className="space-y-3">
            {[
              { name: "tooHigh", label: "Too High" },
              { name: "tooLow", label: "Too Low" },
              { name: "tooSoft", label: "Too Soft" },
              { name: "nasal", label: "Nasal" },
              { name: "hoarse", label: "Hoarse" },
              { name: "congested", label: "Congested" },
              { name: "monotonous", label: "Monotonous" },
              { name: "breathy", label: "Breathy" },
            ].map((option) => (
              <div
                key={option.name}
                className={`flex items-start space-x-3 p-3 rounded-sm border transition-colors ${
                  isReadOnly
                    ? "border-gray-200 bg-gray-50"
                    : formData.voiceConcerns.characteristics?.[option.name]
                    ? "border-primary bg-primary/5"
                    : "border-gray-200 bg-background hover:border-gray-300 hover:bg-accent/30"
                }`}
              >
                <input
                  type="checkbox"
                  id={`voiceCharacteristics-${option.name}`}
                  name={`voiceConcerns.characteristics.${option.name}`}
                  checked={formData.voiceConcerns.characteristics?.[option.name] || false}
                  onChange={handleChange}
                  disabled={isReadOnly}
                  className={`h-4 w-4 rounded-sm border transition-colors focus:ring-1 focus:ring-ring focus:ring-offset-0 ${
                    isReadOnly
                      ? "border-gray-200 bg-gray-50 cursor-not-allowed"
                      : "border-gray-200 text-primary hover:border-gray-300 focus:border-primary"
                  }`}
                />
                <label
                  htmlFor={`voiceCharacteristics-${option.name}`}
                  className={`text-sm leading-relaxed ${
                    isReadOnly ? "text-muted-foreground cursor-not-allowed" : "text-foreground cursor-pointer"
                  }`}
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Other voice concerns */}
        <TextAreaField
          label="Other (please specify)"
          name="voiceConcerns.characteristics.other"
          value={formData.voiceConcerns.characteristics.other}
          onChange={handleChange}
      readOnly={isReadOnly}
        />
      </>
    )}
  </section>
);

export default VoiceConcernsSection;
